export default {"src":"/_next/static/media/empty-cart.120a5c1b.svg","height":216,"width":174,"blurWidth":0,"blurHeight":0};